import { UpgradeRequestsActionTypes } from '../types';
import { makeAsyncActionCreators } from '../../helpers';

const getUpgradeRequests = makeAsyncActionCreators(
  UpgradeRequestsActionTypes.getUpgradeRequests,
  ['filters', 'pagination', 'sortBy'],
  ['requests'],
  ['error'],
);

const getUpgradeRequestsForExcel = makeAsyncActionCreators(
  UpgradeRequestsActionTypes.getUpgradeRequestsForExcel,
  ['filters', 'sortBy'],
  ['requests'],
  ['error'],
);

export default {
  getUpgradeRequests,
  getUpgradeRequestsForExcel,
};
